$(document).on('click touch', '.js-videoPoster' ,function() {
	const _this = $(this);
	const video = _this.parents('.js-video').find('video')[0];

	video.play();
	_this.hide();
})
